export default {
    hight_light: {
        ACTIVE: true,
        INACTIVE: false,
        
    }
}